import React from 'react';

const SvgStarsCheck = (props) => (
  <svg width={'1em'} height={'1em'} {...props}>
    <g
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
    >
      <path
        fillRule="nonzero"
        d="M15.432 8.1l1.937-2.112-5.448-1.086L9.217 0 6.513 4.902 1.065 5.988l3.776 4.116-.662 5.573 5.038-2.359.024.012c.235 2.51 2.324 4.473 4.868 4.473 2.702 0 4.891-2.214 4.891-4.945A4.935 4.935 0 0 0 15.432 8.1zM4.965 14.58l.558-4.702-3.186-3.474 4.596-.916 2.283-4.136 2.283 4.136 4.596.916-1.415 1.543a4.824 4.824 0 0 0-.573-.037c-2.615 0-4.744 2.076-4.878 4.686l-.013-.006-4.25 1.99zm9.144 2.562c-2.341 0-4.24-1.918-4.24-4.286 0-2.367 1.898-4.286 4.24-4.286 2.34 0 4.24 1.919 4.24 4.286 0 2.367-1.9 4.286-4.24 4.286z"
      />
      <path d="M13.186 14.023l-1.383-1.4-.461.468 1.844 1.864 3.69-3.73-.462-.465z" />
    </g>
  </svg>
);

export default SvgStarsCheck;
